<template>
  <div
    class="icon-through v-notification-disabled-icon"
    :class="{ [`color_${color}`]: true, [`bg_${bgColor}`]: !!bgColor }"
    :style="{ zoom: size / 96 }"
  >
    <div class="line-through" />
    <el-icon
      :color="color"
      name="bell-o"
      size="96"
      variant="24"
    />
  </div>
</template>

<script>
  export default {
    name: 'NotificationDisabledIcon',
    props: {
      color: {
        type: String,
        default: 'brand-light'
      },
      size: {
        type: [Number, String],
        default: 96
      },
      bgColor: String
    }
  };
</script>

<style scoped lang="scss">
  .icon-through {
    position: relative;
    display: inline-block;
  }

  .line-through {
    position: absolute;
    left: 50%;
    z-index: $av-z-index-normal;
    width: 8px;
    height: 108px;
    border-radius: 4px;
    box-shadow: -4px -4px 0 $av-inversed-primary;
    transform: rotate(45deg) translateX(-50%);

    .color_brand-light & {
      background: $av-solid-brand-light;
    }

    .color_brand-primary & {
      background: $av-brand-primary;
    }

    .bg_accent & {
      box-shadow: -4px -4px $av-solid-brand-secondary-accent;
    }
  }
</style>
